module.exports = __webpack_public_path__ + "img/video_img.7afdc7bf.png";